/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Hardware_5Inputs */

const en_svr_guidance_hardware_5 = /** @type {(inputs: Svr_Guidance_Hardware_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onsite contact person who knows about the part and their phone number`)
};

const ja_svr_guidance_hardware_5 = /** @type {(inputs: Svr_Guidance_Hardware_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品について知っている現場の連絡先とその電話番号`)
};

const fr_svr_guidance_hardware_5 = /** @type {(inputs: Svr_Guidance_Hardware_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne de contact sur site qui connaît la pièce et son numéro de téléphone`)
};

const de_svr_guidance_hardware_5 = /** @type {(inputs: Svr_Guidance_Hardware_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansprechpartner vor Ort, der über das Teil Bescheid weiß, und Telefonnummer`)
};

/**
* | output |
* | --- |
* | "Onsite contact person who knows about the part and their phone number" |
*
* @param {Svr_Guidance_Hardware_5Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_hardware_5 = /** @type {((inputs?: Svr_Guidance_Hardware_5Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Hardware_5Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_hardware_5(inputs)
	if (locale === "ja") return ja_svr_guidance_hardware_5(inputs)
	if (locale === "fr") return fr_svr_guidance_hardware_5(inputs)
	return de_svr_guidance_hardware_5(inputs)
});